import React from 'react'

export class ErrorPage404 extends React.PureComponent {
    public render() {
        return (
            <div className="errorPage404">
                <h2>Page not found</h2>
                <i className="fa fa-meh-o errorPage404-icon"></i>
                <p>
                    The page that you have requested does not exist! If you feel this page should exist, or you have been linked here by
                    Tideways please sent us an Email to
                    <a href="mailto:support@tideways.io"> support@tideways.io</a>.
                </p>
            </div>
        )
    }
}

export default ErrorPage404
